import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
} from 'axis-components';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseRules, TextValues } from './colorado.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-colorado',
  templateUrl: './colorado.component.html',
  styleUrls: ['./colorado.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    CommonModule,
  ],
})
export class ColoradoComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: import('@angular/forms').FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('colorado', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('colorado', null);
    }
  }
}
